import React, { useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { useHistory } from 'react-router-dom'

import {
  Button,
  SpacingVertical,
  SPACING_24,
  SPACING_8,
  TITLE_VARIANT_M,
  Title,
  Grid,
  GridCell
} from 'mailup-web-components'
import BoxDate from './step4/BoxDate'
import BoxMessages from './step4/BoxMessages'
import BoxProgress from './step4/BoxProgress'
import BoxWinningMessage from './step4/BoxWinningMessage'
import BoxSendWinningMessage from './step4/BoxSendWinningMessage'

import {
  checkScheduleAbTestByIdCallback,
  getAbTestGlobalStatusCallback,
  saveScheduleAbTestByIdCallback
} from '../recoil/callbacks/callbacks'
import {
  abTestState,
  isValidStep4Satate,
  step4State
} from '../recoil/state/abtest'

const AbTestWizard4Step = () => {
  const intl = useIntl()
  const { step1 } = useRecoilValue(abTestState)
  const isValidStep4 = useRecoilValue(isValidStep4Satate)
  const history = useHistory()
  const {
    queueStatus,
    variant,
    queuedPercentage,
    toBeQueued,
    processGlobalStatus,
    changeHistory
  } = useRecoilValue(step4State)

  // const checkProgress = useRecoilCallback(checkProgressCallback, [])
  const getAbTestGlobalStatus = useRecoilCallback(
    getAbTestGlobalStatusCallback,
    []
  )

  const checkScheduleAbTestById = useRecoilCallback(
    checkScheduleAbTestByIdCallback,
    []
  )

  const saveScheduleAbTestById = useRecoilCallback(
    saveScheduleAbTestByIdCallback,
    []
  )

  const timerGlobalStatus = useRef(true)

  useEffect(() => {
    getAbTestGlobalStatus()
  }, [])

  useEffect(() => {
    if (processGlobalStatus) {
      timerGlobalStatus.current = setInterval(() => {
        getAbTestGlobalStatus()
      }, 1000)
      return () => clearInterval(timerGlobalStatus.current)
    }

    if (processGlobalStatus === false) {
      checkScheduleAbTestById()
    }
  }, [processGlobalStatus])

  useEffect(() => {
    changeHistory && history.push(changeHistory)
  }, [changeHistory])

  return (
    <>
      <BoxProgress
        queueStatus={queueStatus}
        variant={variant}
        queuedPercentage={queuedPercentage}
        toBeQueued={toBeQueued}
      />

      <Title variant={TITLE_VARIANT_M}>
        {intl.formatMessage({ id: 'Load.ABTestWizard.TitleTest' })}
      </Title>
      <SpacingVertical variant={SPACING_8} />
      <Grid>
        <GridCell>
          <BoxMessages />
        </GridCell>
        <GridCell>
          <BoxDate />
        </GridCell>
      </Grid>
      {step1.percTest !== 100 && (
        <>
          <Title variant={TITLE_VARIANT_M}>
            {intl.formatMessage({ id: 'Load.ABTestWizard.TitleWinner' })}
          </Title>
          <SpacingVertical variant={SPACING_8} />

          <Grid cols={2}>
            <GridCell span={step1.tipoTest === 'A' ? 1 : 2}>
              <BoxWinningMessage />
            </GridCell>
            {step1.tipoTest === 'A' && (
              <GridCell span={1}>
                <BoxSendWinningMessage />
              </GridCell>
            )}
          </Grid>
        </>
      )}

      <SpacingVertical variant={SPACING_24} />
      <Button
        kind='primary'
        onClick={saveScheduleAbTestById}
        disabled={!isValidStep4}
      >
        {intl.formatMessage({
          id: 'Load.MailupCommon.Save'
        })}
      </Button>
      <SpacingVertical variant={SPACING_24} />
    </>
  )
}

export default AbTestWizard4Step
